module.exports = __webpack_public_path__ + "static/media/assignment.4e1a47fc.png";